import React, { ReactNode, useState } from 'react';

type IAppLangContext = {
	language: string;
	changeLanguage: (lang: string) => void;
};

const AppLangContext = React.createContext<IAppLangContext>({
	language: localStorage.getItem('appLang') ?? navigator.language.slice(0, 2), // Valeur par défaut
	changeLanguage: () => {
		null;
	},
});

export const useAppLang = () => {
	return React.useContext(AppLangContext);
};

type AppLangProviderProps = {
	children?: ReactNode;
};

const AppLangProvider: React.FC<AppLangProviderProps> = ({ children }) => {
	const [language, setLanguage] = useState(
		localStorage.getItem('appLang') ?? navigator.language.slice(0, 2).toLowerCase(),
	);
	const changeLanguage = (lang: string) => {
		setLanguage(lang.toLowerCase());
		localStorage.setItem('appLang', lang);
	};

	const contextValue = React.useMemo(() => {
		return {
			language: language.toLowerCase(),
			changeLanguage,
		};
	}, [language]);

	return <AppLangContext.Provider value={contextValue}>{children}</AppLangContext.Provider>;
};

export default AppLangProvider;
